'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { ReactNode } from 'react'
import { useSidebarLayoutContext } from './use-sidebar-layout.ts'

type SidebarLayoutContentProps = {
  children: ReactNode
  className?: string
}

const SidebarLayoutContent = ({
  children,
  className,
}: SidebarLayoutContentProps) => {
  const { clampWidthClassName } = useSidebarLayoutContext()

  return (
    <div className="w-full flex-1">
      <div className={cn('lg:p-8 mx-auto', clampWidthClassName, className)}>
        {children}
      </div>
    </div>
  )
}

export { SidebarLayoutContent }
